import React, { useEffect, useState } from "react";
import { StudentTestData } from "../../../api/StudentServices";
import { ToastMain, SweetAlertShow } from "../../master/Master";

const MarksReportTab = ({ data }) => {
  const student = data?.student || {};
  const student_id = student?.id;
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(false);

  const getTestData = async (student_id) => {
    setLoading(true);
    try {
      const response = await StudentTestData(student_id);

      if (response?.data?.status) {
        const courses = response.data.data.course_and_fees || [];

        // 👉 Extract all tests from all courses
        const allTests = courses.map((item) => item.tests || []).flat(); // merge all array

        setTests(allTests);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (student_id) getTestData(student_id);
    else console.log("Student id not found", student_id);
  }, [student_id]);

  if (loading) return <p>Loading...</p>;

  return (
    <div className="row">
      <div>
        <hr />
      </div>

      {tests.length === 0 ? (
        <p>No tests available</p>
      ) : (
        tests.map((test, index) => (
          <div key={test.id} className="card mb-4 shadow-sm p-3">
            <div className="d-flex justify-content-between">
              <h4 className="text-primary">
                {index + 1}. {test?.title || "Untitled Test"}
              </h4>
              <span className="text-primary mt-3">{test?.date}</span>
            </div>

            <p>
              <b>Total Marks:</b> {test?.marks?.total_marks || 0} |{" "}
              <b>Obtained:</b> {test?.marks?.obtained_total || 0} | <b>Rank:</b>{" "}
              {test?.marks?.rank || "-"}
            </p>

            <table className="table table-responsive mt-2">
              <thead className="table-label-primary align-center text-center">
                <tr>
                  <th>Subject</th>
                  <th>Total Marks</th>
                  <th>Obtained Marks</th>
                </tr>
              </thead>
              <tbody className="align-start">
                {test?.marks?.obtained_list?.map((subj) => (
                  <tr key={subj.id}>
                    <td>{subj.name}</td>
                    <td>{subj.marks}</td>
                    <td>{subj.obtained_marks}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))
      )}
    </div>
  );
};

export default MarksReportTab;
